<div class="control-section drag">
  
  <ejs-dialog #modalphoihop [buttons]='dlgButtons' [position]='position' [visible]='false' [header]='modalTitle' [animationSettings]='animationSettings'
              [resizeHandles]='resizeHandleDirection' [enableResize]='dialogResize' [allowDragging]='dialogdragging'
              [target]='target'
              [showCloseIcon]='false' [width]='width' (open)="dialogOpen()" (close)="dialogClose()">
    <app-tonghop-donviphoihopedit #ctdonviphoihopedit (savect)="savept($event)"></app-tonghop-donviphoihopedit>
    <ng-template #footerTemplate>
    </ng-template>
  </ejs-dialog>
</div>

<div style="padding: 2px 0px 10px 10px;color:black !important">
  <!--danh sach công văn-->
  <div style="width:39%;float:left;height: 100%">
    <div>
      <div style="display: flex;justify-content: space-between;">
        <ul class="nav nav-tabs" ng-reflect-klass="nav" ng-reflect-ng-class="[object Object]" style="width:100%;">
          <li class="nav-item ng-star-inserted" [ngClass]="{'active': tabselected==1}"><a (click)="selectTab(1)" class="nav-link" [ngClass]="{'active': tabselected==1}" href="javascript:void(0);" id=""><span></span>Chờ xử lý</a></li>
          <li class="nav-item ng-star-inserted" [ngClass]="{'active': tabselected==2}"><a (click)="selectTab(2)" class="nav-link" [ngClass]="{'active': tabselected==2}" href="javascript:void(0);" id=""><span></span>Đã chuyển</a></li>
          <li class="nav-item ng-star-inserted" [ngClass]="{'active': tabselected==3}"><a (click)="selectTab(3)" class="nav-link" [ngClass]="{'active': tabselected==3}" href="javascript:void(0);" id=""><span></span>Xem để biết</a></li>
          <li class="nav-item ng-star-inserted" [ngClass]="{'active': tabselected==4}"><a (click)="selectTab(4)" class="nav-link" [ngClass]="{'active': tabselected==4}" href="javascript:void(0);" id=""><span></span>Đã kết thúc</a></li>
        </ul>
      </div>

      <div class="tab-content" style="padding: 1px 15px !important">
        <div class=" tab-pane" [ngClass]="{'active': tabselected==1}">
          <div class="row" style="overflow:auto;height: calc(100vh - 120px);background:#e4e6e9" *ngIf="tabselected==1">
            <div class="" style="height: 100%;background:#fff;">
              <!--<table class="table table-striped table-bordered table-hover">-->
              <table class="table">
                <thead [ngClass]="{'theadcss': totalItems>16}">
                  <tr>
                    <td>
                      <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                             [(ngModel)]="TimKiems.TimKiem" placeholder="Tìm kiếm trích yếu, số ký hiệu" (ngModelChange)="search()">
                    </td>
                  </tr>

                </thead>
                <tbody style="height: calc(100vh - 180px)">
                  <tr *ngFor="let u of datas" [ngClass]="{'rowItem_Selected': u.Id==tId}" (click)="selected(u)">
                    <!--<td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>-->
                    <td style="width:30px"><div class="rowItemreaded"></div></td>
                    <td>
                      <a (click)="selected(u)" *ngIf="u.da_doc==0">
                        <div class="row">
                          <div class="cssSokyhieu">{{u.so_ky_hieu}}</div>
                          <div class="cssNgayVB_old">{{u.ngay_phan | date:'dd/MM/yy HH:mm' }}</div>
                        </div>
                        <div class="row cssNoigui"> {{u.noi_gui}}</div>
                        <div class="row cssTrichyeu rowItem_Quahan" *ngIf="u.qua_han==1">{{u.trich_yeu}}</div>
                        <div class="row cssTrichyeu" *ngIf="u.qua_han!==1">{{u.trich_yeu}}</div>
                      </a>
                      <a (click)="selected(u)" *ngIf="u.da_doc!==0" class="rowItem_Unread">
                        <div class="row">
                          <div class="cssSokyhieu">{{u.so_ky_hieu}}</div>
                          <div class="cssNgayVB_old">{{u.ngay_phan | date:'dd/MM/yy HH:mm' }}</div>
                        </div>
                        <div class="row cssNoigui"> {{u.noi_gui}}</div>
                        <div class="row cssTrichyeu rowItem_Quahan" *ngIf="u.qua_han==1">{{u.trich_yeu}}</div>
                        <div class="row cssTrichyeu" *ngIf="u.qua_han!==1">{{u.trich_yeu}}</div>
                      </a>
                    </td>
                    <td style="width:30px">
                      <div style="float:right;top:0;padding-left:4px;" title="Chọn nhiều văn bản để xử lý cùng lúc." class="checkbox">
                        <label><input id="chkMulti" type="checkbox" [(ngModel)]="u.Tich" value=""><span class="cr"></span></label>
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
        <div class=" tab-pane" [ngClass]="{'active': tabselected==2}">
          <div class="row" style="overflow:auto;height: calc(100vh - 120px);background:#e4e6e9" *ngIf="tabselected==2">
            <div class="" style="height: 100%;background:#fff;">
              <!--<table class="table table-striped table-bordered table-hover">-->
              <table class="table">
                <thead [ngClass]="{'theadcss': totalItems>16}">
                  <tr>
                    <td>
                      <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                             [(ngModel)]="TimKiems.TimKiem" placeholder="Tìm kiếm trích yếu, số ký hiệu" (ngModelChange)="search()">
                    </td>
                  </tr>

                </thead>
                <tbody style="height: calc(100vh - 180px)">
                  <tr *ngFor="let u of datas" [ngClass]="{'rowItem_Selected': u.Id==tId}" (click)="selected(u)">
                    <!--<td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>-->
                    <td style="width:30px"><div class="rowItemreaded"></div></td>
                    <td>
                      <a (click)="selected(u)">
                        <div class="row">
                          <div class="cssSokyhieu">{{u.so_ky_hieu}}</div>
                          <div class="cssNgayVB_old">{{u.ngay_phan | date:'dd/MM/yy HH:mm' }}</div>
                        </div>
                        <div class="row cssNoigui"> {{u.noi_gui}}</div>
                        <div class="row cssTrichyeu">{{u.trich_yeu}}</div>
                      </a>
                    </td>
                    <td style="width:30px">
                      <div style="float:right;top:0;padding-left:4px;" title="Chọn nhiều văn bản để xử lý cùng lúc." class="checkbox">
                        <label><input id="chkMulti" type="checkbox" [(ngModel)]="u.Tich" value=""><span class="cr"></span></label>
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class=" tab-pane" [ngClass]="{'active': tabselected==3}">
          <div class="row" style="overflow:auto;height: calc(100vh - 120px);background:#e4e6e9" *ngIf="tabselected==3">
            <div class="" style="height: 100%;background:#fff;">
              <!--<table class="table table-striped table-bordered table-hover">-->
              <table class="table">
                <thead [ngClass]="{'theadcss': totalItems>16}">
                  <tr>
                    <td>
                      <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                             [(ngModel)]="TimKiems.TimKiem" placeholder="Tìm kiếm trích yếu, số ký hiệu" (ngModelChange)="search()">
                    </td>
                  </tr>

                </thead>
                <tbody style="height: calc(100vh - 180px)">
                  <tr *ngFor="let u of datas" [ngClass]="{'rowItem_Selected': u.Id==tId}" (click)="selected(u)">
                    <!--<td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>-->
                    <td style="width:30px"><div class="rowItemreaded"></div></td>
                    <td>
                      <a (click)="selected(u)">
                        <div class="row">
                          <div class="cssSokyhieu">{{u.so_ky_hieu}}</div>
                          <div class="cssNgayVB_old">{{u.ngay_phan | date:'dd/MM/yy HH:mm' }}</div>
                        </div>
                        <div class="row cssNoigui"> {{u.noi_gui}}</div>
                        <div class="row cssTrichyeu rowItem_Quahan" *ngIf="u.qua_han==1">{{u.trich_yeu}}</div>
                        <div class="row cssTrichyeu" *ngIf="u.qua_han!==1">{{u.trich_yeu}}</div>
                      </a>
                    </td>
                    <td style="width:30px">
                      <div style="float:right;top:0;padding-left:4px;" title="Chọn nhiều văn bản để xử lý cùng lúc." class="checkbox">
                        <label><input id="chkMulti" type="checkbox" [(ngModel)]="u.Tich" value=""><span class="cr"></span></label>
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class=" tab-pane" [ngClass]="{'active': tabselected==4}">
          <div class="row" style="overflow:auto;height: calc(100vh - 120px);background:#e4e6e9" *ngIf="tabselected==4">
            <div class="" style="height: 100%;background:#fff;">
              <!--<table class="table table-striped table-bordered table-hover">-->
              <table class="table">
                <thead [ngClass]="{'theadcss': totalItems>16}">
                  <tr>
                    <td>
                      <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                             [(ngModel)]="TimKiems.TimKiem" placeholder="Tìm kiếm trích yếu, số ký hiệu" (ngModelChange)="search()">
                    </td>
                  </tr>

                </thead>
                <tbody style="height: calc(100vh - 180px)">
                  <tr *ngFor="let u of datas" [ngClass]="{'rowItem_Selected': u.Id==tId}" (click)="selected(u)">
                    <!--<td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>-->
                    <td style="width:30px"><div class="rowItemreaded"></div></td>
                    <td>
                      <a (click)="selected(u)">
                        <div class="row">
                          <div class="cssSokyhieu">{{u.so_ky_hieu}}</div>
                          <div class="cssNgayVB_old">{{u.ngay_phan | date:'dd/MM/yy HH:mm' }}</div>
                        </div>
                        <div class="row cssNoigui"> {{u.noi_gui}}</div>
                        <div class="row cssTrichyeu">{{u.trich_yeu}}</div>
                      </a>
                    </td>
                    <td style="width:30px">
                      <div style="float:right;top:0;padding-left:4px;" title="Chọn nhiều văn bản để xử lý cùng lúc." class="checkbox">
                        <label><input id="chkMulti" type="checkbox" [(ngModel)]="u.Tich" value=""><span class="cr"></span></label>
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!--*ngIf="totalItems>=10"-->
        <div>
          <ul class="pagination" *ngIf="totalItems>=20">
            <li [ngClass]="{disabled: currentPage === 1}">
              <a (click)="setPage(1)"><<</a>
            </li>
            <li [ngClass]="{disabled:currentPage === totalPages}">
              <a (click)="setPage(currentPage - 1)"><</a>
            </li>
            <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
              <a (click)="setPage(page.Id)">{{page.Id}}</a>
            </li>
            <li [ngClass]="{disabled:currentPage === 1}">
              <a (click)="setPage(currentPage + 1)">></a>
            </li>
            <li [ngClass]="{disabled:currentPage === totalPages}">
              <a (click)="setPage(totalPages)">>></a>
            </li>
            <li>
              <input type="number" style="width:50px;height:22px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
            </li>
            <li><span style="font-weight:bold">{{totalItems | number}}</span></li>

          </ul>
        </div>

      </div>

    </div>
  </div>

  <div style="width:61%;float:left">
    <div style="width:100%">
      <div id="divDask" style="float: right; height: 25px; padding-top: 1px; border-bottom: thin solid rgba(0, 0, 0, 0.09); width: 100%;">
        <div style=" width:100%; height:25px; color:gray;">
          <div style="float:right; width:32%;  height:22px; padding-left:1%;border-left:1px solid silver; ">
            <div class="css_dask_left">Quá hạn</div>
            <div class="css_dask_right"><div id="divVBquahan" class="so_dask_quahan" title="xem chi tiết">{{slquahan}}</div></div>
          </div>
          <div style="float:right; width:32%; height:22px;  padding-left:1%; border-left:1px solid silver">
            <div class="css_dask_left">Sắp quá hạn</div>
            <div class="css_dask_right"><div id="divVBsapquahan" class="so_dask_quahan" title="xem chi tiết">{{slsapquahan}}</div></div>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="clear-fix"></div>-->
    <div style="width:100%; overflow:auto;height: calc(100vh - 100px)">
      <div id="divXulyHtml" style="width: 100%" *ngIf="selectedRow!==null">
        <input type="text" id="File_tmp" style="display:none" tabindex="0">
        <div id="div_vanbaninfor" style="height:auto;border:none; float:left; width:100%;background-color:white;">
          <div style="width:100%; padding:0px;">
            <div class="lbl" id="divtheolo" style="display:none;">
            </div>
            <div class="lbl" id="div101" style="border:none; width:12%;padding-right:1%; text-align:right;color:gray;text-decoration:underline;">Nơi gửi</div>
            <div class="lbl" style=" float:left; width:85%; height:auto;display:flex">
              <div style="float:left;width:80%;font-weight:bold; ">
                <div id="lblNoiGui"> {{selectedRow.noi_gui}}</div>
              </div><div style="float:left;width:20%; text-align:center; color:#c59a35;">
                <div id="lblhangq">Hạn gq:{{selectedRow.han_gq | date: 'dd/MM'}}</div>
              </div>
            </div>
            <div id="Div2" class="lbl" style="border:none;width:2%;">&nbsp; </div>
            <div class="lbl" id="div102" style="border:none;width:12%;padding-right:1%; text-align:right;color:gray;text-decoration:underline;height:auto">Trích yếu</div>
            <div class="lbl" style="width:84%;font-weight:bold;height:auto;"><div id="lblTrichyeu" style="color:#404040">{{selectedRow.trich_yeu}}</div></div><div style=" clear:both">
            </div><div id="Div5" class="lbl" style="border:none;width:13%; height:auto">&nbsp;</div>
            <div class="lbl" style=" float:left; width:84%; height:auto;border-style:none">
              <div id="lblFile">
                <div *ngFor="let u of VanBanSelected.Anhs">
                  <img src="{{u.icon}}" border="0" width="13" height="13"><a href="{{u.File_Path}}" return="" false="" tabindex="0" target="_blank">{{u.file_name}}</a>
                </div>
              </div>
            </div>
            <div class="lbl" style="width:98%; border:none; height:auto;">
              <div id="lblChidao">
                <div [innerHtml]="transformYourHtml(VanBanSelected.chi_dao)"></div>
                <!--<div class="bubbleyou_cd_new">
              <div class="bubbleyou_cd_new_ld">
                <div class="cls_avata">
                  <div class="user_img" style="background-image:url(UserImg/162475.png),url(UserImg/empty.png);"></div>
                </div><div class="cls_chidao_right">
                  <div class="cls_nguoicd">
                    <b>Chu Thị Thu Hương</b><br>
                    <span class="cls_chucvu">Phó Tổng cục trưởng</span><br><span class="cls_timecd">05/08 16:36</span>
                  </div>
                  <div class="cls_noidungcd"><hr style="padding:0px !important;margin: 0px !important">K/c:Tổng Cục trưởng;Vụ CS-PC;Cục QLTT Hòa Bình</div>
                </div>
              </div>
            </div>-->
              </div>
            </div>
          </div>
        </div>
        <div id="div3" style="height:2px;  float:left; width:100%; border:none; background-color:#EEEEEF; "></div>
        <div id="div_noinhan" style="float: left; display: block; width: 100%; height: auto; border: 0px solid rgb(229, 229, 229);">
          <div style="cursor:pointer; width:71%; float:left;background-color:#FBFBFB;  " (dblclick)="chondonvi('1')">
            <div class="lbl_chitiet" style="width:15%; text-align:right;height:24px;">
              <div>Chỉ đạo:</div>
            </div>
            <div class="lbl_chitiet" style=" width:84%;height:24px;">
              <div id="lbl_chidao" style="color:gray; font-weight:bold">
                {{doituongSelect.NN_ChiDao}}
              </div>
            </div>
            <div class="lbl_chitiet" style="width:15%; text-align:right;height:24px;">
              <div>Chủ trì:</div>
            </div>
            <div class="lbl_chitiet" style=" width:84%;height:24px;">
              <div id="lbl_chutri" style="color:red; font-weight:bold">
                {{doituongSelect.NN_ChuTri}}
              </div>
            </div>
            <div class="lbl_chitiet" style="width:15%; text-align:right;height:44px; ">
              <div>Phối hợp:</div>
            </div><div class="lbl_chitiet" style="width:84%;height:44px;overflow:auto">
                    <div id="lbl_phoihop" style="color:blue; font-weight:bold">
                      {{doituongSelect.NN_PhoiHop}}
                    </div>
            </div>
            <div class="lbl_chitiet" style="width:15%; text-align:right;height:45px;"><div>Để biết:</div></div>
            <div class="lbl_chitiet" style="width:84%;height:44px;overflow:auto">
              <div id="lbl_debiet" style="color:Olive; font-weight:bold">
                {{doituongSelect.NN_DeBiet}}
              </div>
            </div>
          </div>
          <div class="cssbtnChidao" (dblclick)="chondonvi('1')">
            <div class="css_xuly_GD" title="Chọn nơi nhận xử lý văn bản">
            </div>
          </div>
          <div style="width:22%; background-color:#FBFBFB; float:right; margin-top:4px; height:104px;">
            <div style="float:left;width:25%;  height:28px; padding-top:4px">Hạn</div>
            <div style="float:left;width:75%;  height:28px">
              <ejs-datepicker [format]="format" [enableMask]="enableMaskSupport" [(value)]='ChuyenBoPhan.Han_GQ'></ejs-datepicker>
              <!--<input type="text" class="txt_css hasDatepicker" readonly="" style="width:96px" id="txtHanGQ" tabindex="0">-->
            </div>
            <div style="float:left;width:100%; text-align:left;height:28px">
              <div class="checkbox">
                <label><input id="chkTraLoi" type="checkbox"  [(ngModel)]='ChuyenBoPhan.tt' tabindex="0">Yêu cầu trả lời</label>
              </div>
            </div>
            <div style="float:left; width:125px; height:28px;">

              <ng-select #slNoiGui
                         labelForId="99"
                         class="twcol"
                         [tabIndex]="5"
                         [openOnEnter]="false"
                         [items]="inputdokhans"
                         bindValue="Id"
                         bindLabel="Ten"
                         notFoundText="Không có dữ liệu"
                         placeholder="Độ khẩn"
                         [(ngModel)]="ChuyenBoPhan.do_khan">
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">

                    >

                    <!--<div class="rTableCell rTableCell-1">{{item.Ma}}</div>-->
                    <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
                  </div>

                </ng-template>
              </ng-select>

              <!--<select id="Opt_dk" class="cssmySelect2 select2-hidden-accessible" style="width:125px" data-select2-id="Opt_dk" tabindex="-1" aria-hidden="true">
            <optgroup label="Chọn trạng thái">
              <option value="0" data-select2-id="50">Bình thường</option>
              <option value="1">Khẩn</option>
              <option value="2">Thượng khẩn</option>
            </optgroup>
          </select>-->

            </div>
          </div>
        </div><div id="div_noidung" style="display: block; width: 100%; overflow: hidden; height: auto; border-style: none; background-color: rgb(250, 250, 250);">
          <div class="lbl_chitiet" style="float:left; width:10%; height:100px; background-color:#FAFAFA; border-bottom:none "></div>
          <div class="lbl_chitiet" style="float:left;width:85%; text-align:left; height:100px;background-color:#FAFAFA;border-bottom:none">
            <textarea name="txtNoidung" rows="2" cols="20" id="txtNoidung" class="txt_css" placeholder="Nội dung xử lý..."
                      style="height:82px;width:97%;resize:none; font-family:Roboto; font-size:small; padding:6px" tabindex="0"
                      [(ngModel)]='ChuyenBoPhan.giai_quyet'></textarea>
          </div>
          <input type="file" id="fileUpload" name="fileupload" style="display: none" tabindex="0"><div class="cssUpload" id="btn_attach" title="File đính kèm (nếu có)"><i class="css_file"></i></div>
          <div class="lbl_chitiet" style="width:100%;text-align:left; height:auto; border-bottom:none">
            <div id="litsFile" style="padding:5px; width:95%;background-color:#FAFAFA; ">
            </div>
          </div><div style=" float:left;width:100%; border:none;background-color:#FAFAFA ;">
            <div class="cssDropdownbtn" data-jq-dropdown="#TaoVBDi" style="float:left;padding:7px; border:none;text-decoration: underline; border-radius:3px">Tạo văn bản đi/lưu hồ sơ</div>
            <div style="float:right;width:20%; text-align:left; padding-top:3px; padding-left:3px; ">
              <div class="checkbox">
                <label class="css_link_ct">
                  <input id="chkChuyennham" type="checkbox" [(ngModel)]='ChuyenBoPhan.chuyen_nham' tabindex="0">Chuyển nhầm
                </label>
              </div>
            </div>
            <div style="float:right;width:16%; text-align:center; padding-top:3px; padding-left:3px;">
              <div class="checkbox">
                <label class="css_link_ct"><input id="chkKetthuc" type="checkbox"  [(ngModel)]='ChuyenBoPhan.ket_thuc' (ngModelChange)="changeKT()" tabindex="0">Kết thúc</label>
              </div>
            </div>
            <div style="float:right;width:20%; text-align:right;">
              <div id="btnXulyMain" class="cssbtnXulymain">
                <button class="mb-1 mr-1 btn btn-primary" (click)="savectu(0)">
                  Lưu lại
                </button>
              </div>
            </div>
            <div style="float:right;text-align:right;padding-top:2px"><input id="Tyle" [(ngModel)]="ChuyenBoPhan.Tyle" style="width:47px;text-align:center;color:blue;border:1px solid #d5d5d5;" type="number" min="0" max="100" tabindex="0">%</div>
          </div>
        </div>
      </div>


      <!--tree xử lý-->
      <div id="divTreeXuly" style="width: 98%; display: block;" *ngIf="selectedRow!==null">
        <div id="RadTreeList2Panel" style="display: block;">
          <div id="RadTreeList2" class=" RadTreeList RadTreeList_Clear">
            <!-- 2012.3.1205.35 -->
            <table border="0" style="display: table" cellspacing="0" class="rtlTable rtlLines rtlHBorders">
              <!--<colgroup>
            <col style="width:23px;">
            <col style="width:23px;">
            <col style="width:160px;">
            <col style="width:30px;">
            <col>
            <col style="width:30px;">
            <col style="width:30px;">
          </colgroup>-->
              <thead>
                <tr class="rtlHeader">
                  <!--<th scope="col" class="rtlCF" colspan="3">&nbsp;</th>
              <th scope="col"></th>
              <th scope="col" style="text-align:center;">&nbsp;</th>
              <th scope="col"></th>
              <th scope="col"></th>-->
                  <th style="width:23px"></th>
                  <th style="width:160px"></th>
                  <th style="width:30px"></th>
                  <th style="width:260px"></th>
                  <th style="width:30px"></th>
                  <th style="width:30px"></th>
                </tr>
              </thead>
              <tbody style="display: table-row-group;">
                <!--*ngFor='let row of baivietSelect.TuKhoas; let i = index'-->
                <tr *ngFor='let row of VanBanSelected.QiaiQuyets; let i = index' class="rtlR" id="RadTreeList2_ctl02__{{i}}" style="color:Blue">
                  <td *ngIf="row.PID==null" class="rtlL" style="width:23px"><input type="button" name="RadTreeList2$ctl02$ExpandCollapseButton" value=" " id="RadTreeList2_ctl02_ExpandCollapseButton{{i}}" class="rtlCollapse"></td>
                  <td *ngIf="row.PID==null" class=" rtlCF" colspan="2" style="width:160px"><div [innerHtml]="transformYourHtml(row.ten)"></div></td>
                  <td *ngIf="row.PID==null" style="width:30px">
                    <img *ngIf="row.tt_xl==1" id="RadTreeList2_ctl02_tt_xl{{i}}" title="Đã kết thúc!" src="Img/ketthuc.png" style="border-width:0px;">
                  </td>
                  <td *ngIf="row.PID==null">
                    <div [innerHtml]="transformYourHtml(row.GIAI_QUYET)"></div>
                    <!--<a style="float:left" (click)="openFiles_html('3270202110071825468706.xls');">danh_sach_Quan-ly-cap-phat-the-tranh-tra--thu-hoi-the-thanh-tra--in-the (4).xls</a>-->

                  </td>


                  <td *ngIf="row.PID!==null" class="rtlL" style="width:23px">&nbsp;</td>
                  <td *ngIf="row.PID!==null" class="rtlL rtlL2" style="width:13px">&nbsp;</td>
                  <td *ngIf="row.PID!==null" class=" rtlCF" colspan="1" style="width:160px">
                    <div *ngIf="row.ten!==null" [innerHtml]="transformYourHtml(row.ten)"></div>
                  </td>
                  <td *ngIf="row.PID!==null" style="width:30px">
                    <img *ngIf="row.tt_xl==1" id="RadTreeList2_ctl04_tt_xl{{i}}" title="Đã kết thúc!" src="Img/ketthuc.png" style="border-width:0px;">
                  </td>
                  <td *ngIf="row.PID!==null">
                    <div [innerHtml]="transformYourHtml(row.GIAI_QUYET)"></div>

                    <!--<a style="float:left" (click)="openFiles_html('3270202110071825468706.xls')">danh_sach_Quan-ly-cap-phat-the-tranh-tra--thu-hoi-the-thanh-tra--in-the (4).xls</a>-->

                  </td>

                  <td style="width:30px">
                    <input type="button" *ngIf="row.ma_quyen==3" name="RadTreeList2$ctl05$btnXuly" value="" id="RadTreeList2_ctl05_btnXuly{{i}}" title="Bổ sung ý kiến cho bộ phận này" class="css_btn_bs">
                  </td>

                </tr>



              </tbody>
            </table><input id="RadTreeList2_ClientState" name="RadTreeList2_ClientState" type="hidden" autocomplete="off">
          </div>
        </div>
      </div>

       

      <div id="divXulyHtml2" style="width: 100%" *ngIf="selectedRow==null">
        <div id="divRightMain_Xuly" class="MyScroll ps-container ps-theme-default">
          <div id="divLichtuan">
            <div>
                    <div class="MyScroll ps-container ps-theme-default" style="border-right:1px solid rgba(0, 0, 0, 0.09);border-left:1px solid rgba(0, 0, 0, 0.09); position:relative;overflow:auto;background-color:white;" data-ps-id="4c4bbcae-173b-6416-1355-a7dfcd31f350">
                      <div class="rowHearderItemNew" style="position:relative;border:1px solid rgba(0, 0, 0, 0.09);">
                        <div class="cssHearderThoigian">T.gian</div>
                        <div class="cssHearderDiaiem">Địa điểm</div><div class="cssHearderChutri">Chủ trì</div>
                        <div class="cssHearderNoiDung" style="width:40%">Nội dung</div><div class="cssHearderThanhPhan">Thành phần</div>
                      </div>
                      <div id="divContents">
                        <!--onclick="jsToggleLich(1)"-->
                        <div class="rowItemNew" *ngIf="lichtuans">
                        <div style="width:100%;border-left:thin solid rgba(0, 0, 0, 0.09);font-size: large; color:gray; text-align:center;float:left;padding:4px">(CHƯA CÓ LỊCH)</div>
                        </div>
                        <div *ngFor="let u of lichtuans; let i = index">
                          <div class="cssTabGroup">
                            <div style="width:100%;float:left">{{u.Ngay}}</div>
                          </div>
                          <div id="divDate{{i}}">
                            <div class="rowItemNew" *ngFor="let u1 of u.LichTuans">
                              <div class="cssRowThoigian">{{u1.GIO_PHUT}}<br>-<br>{{u1.GIO_PHUT1}}</div><div class="cssRowDiaiem">{{u1.Dia_Diem}}</div>
                              <div class="cssRowChutri">{{u1.Chu_Tri}}</div><div class="cssRowNoiDung" title="Người nhập:{{u1.nguoi_dangky}}" style="width:40%">
                                <div>
                                  <div>{{u1.Noi_Dung}}</div>
                                  <div style="float:left; width:25%;text-decoration:underline;font-size:11px; color:silver;font-style:italic">Chuẩn bị:</div>
                                  <div style="float:left; width:75%;font-size:11px; color:DarkBlue ">{{u1.Chuan_Bi}}</div>
                                </div>
                              </div>
                              <div class="cssRowThanhPhan">{{u1.Thanh_Phan}}</div>
                            </div>
                            <!--<div class="rowItemNew" onclick="openXem_Lich();">
        <div class="cssRowThoigian">8:30<br>-<br>11:00</div><div class="cssRowDiaiem">Phòng họp 1, Tầng 2 Trụ sở Tổng cục </div>
        <div class="cssRowChutri">Bí thư Chi bộ</div><div class="cssRowNoiDung" title="Người nhập:Lê Nhật Minh" style="width:40%">
          <div>
            <div>Sinh hoạt thường kỳ</div>
            <div style="float:left; width:25%;text-decoration:underline;font-size:11px; color:silver;font-style:italic">Chuẩn bị:</div>
            <div style="float:left; width:75%;font-size:11px; color:DarkBlue ">CNV</div>
          </div>
        </div><div class="cssRowThanhPhan">Đảng viên Chi bộ CNV</div>
      </div>
      <div class="rowItemNew" onclick="openXem_Lich();">
        <div class="cssRowThoigian">14:30<br>-<br>16:00</div>
        <div class="cssRowDiaiem">Phòng họp 1</div><div class="cssRowChutri">Chi bộ Vụ THKHTC</div><div class="cssRowNoiDung" title="Người nhập:Lê Nguyễn Thu Anh" style="width:40%">
          <div>
            <div>Sinh hoạt chi bộ thường kỳ Tháng 11 </div>
            <div style="float:left; width:25%;text-decoration:underline;font-size:11px; color:silver;font-style:italic">Chuẩn bị:</div>
            <div style="float:left; width:75%;font-size:11px; color:DarkBlue ">Chi bộ Vụ THKHTC</div>
          </div>
        </div><div class="cssRowThanhPhan">Các đảng viên trong Chi bộ</div>
      </div>
      <div class="rowItemNew" onclick="openXem_Lich();">
        <div class="cssRowThoigian">16:30<br>-<br>18:00</div><div class="cssRowDiaiem">Phòng họp 2</div>
        <div class="cssRowChutri">Bí thư Chi bộ</div><div class="cssRowNoiDung" title="Người nhập:Lê Thị Minh Huệ" style="width:40%">
          <div>
            <div>Sinh hoạt chi bộ tháng 11</div>
            <div style="float:left; width:25%;text-decoration:underline;font-size:11px; color:silver;font-style:italic">Chuẩn bị:</div>
            <div style="float:left; width:75%;font-size:11px; color:DarkBlue ">Chi bộ Vụ Thanh tra - Pháp chế</div>
          </div>
        </div><div class="cssRowThanhPhan">Các đảng viên chi bộ</div>
      </div>-->
                          </div>
                        </div>

                      </div>

                      <!--<div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px;">
                        <div class="ps-scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div>
                      </div>
                      <div class="ps-scrollbar-y-rail" style="top: 0px; right: 0px;">
                        <div class="ps-scrollbar-y" tabindex="0" style="top: 0px; height: 0px;">
                        </div>
                      </div>-->

                    </div>
            </div>
            <!--<div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px;">
              <div class="ps-scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div>
            </div>
            <div class="ps-scrollbar-y-rail" style="top: 0px; right: 0px; height: 573px;">
              <div class="ps-scrollbar-y" tabindex="0" style="top: 0px; height: 318px;">
              </div>
            </div>-->
          </div>
        </div>
      </div>




    </div>


  </div>
</div>
